export interface InstanceRequest {
  id: number;
  email: string;
  agencyName?: string;
  phone?: string;
  rejectComment?: string;
  state: InstanceRequestState;
}
export interface InstanceRequestToApprove {
  agencyName: string;
  phoneNumber: string;
  domainName: string;
  tier: number;
}

export enum InstanceRequestState {
  Approved = 0,
  Pending = 1,
  Rejected = 2,
}
